import type React from 'react';

interface ArizonaSvgProps {
    color?: string;
    opacity?: number;
}

const ArizonaSvg: React.FC<ArizonaSvgProps> = ({ color = '#D91667', opacity = 1 }) => (
    <svg width="44" height="50" viewBox="0 0 44 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity={opacity}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.6709 2.51511C29.3075 3.22645 42.5807 4.36842 42.5807 4.36842L38.933 49L25.4645 47.8772L1.33337 35.807L1.61397 34.9649L2.17516 34.1228L2.45575 33.8421L3.29753 34.1228H3.57813L4.13931 33V31.8772L3.01694 31.5965L2.73634 31.0351L3.01694 30.193V28.5088H3.85872L4.41991 27.386L4.9811 25.1404V24.5789L5.54228 24.0175L5.82288 23.4561L6.94525 22.8947L7.78704 22.0526L6.38407 20.6491L6.10347 18.9649L5.26169 17.2807V15.3158L5.82288 15.0351V13.9123L5.54228 12.5088L5.82288 11.6667L5.54228 10.2632L5.82288 9.70175L5.54228 8.85965L5.82288 7.73684L6.94525 7.17544L7.78704 7.73684L8.34822 7.45614L8.62882 8.57895H9.4706L10.3124 6.89474L11.1542 1C11.1542 1 18.832 2.10364 22.6709 2.51511Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.6709 2.51511C29.3075 3.22645 42.5807 4.36842 42.5807 4.36842L38.933 49L25.4645 47.8772L1.33337 35.807L1.61397 34.9649L2.17516 34.1228L2.45575 33.8421L3.29753 34.1228H3.57813L4.13931 33V31.8772L3.01694 31.5965L2.73634 31.0351L3.01694 30.193V28.5088H3.85872L4.41991 27.386L4.9811 25.1404V24.5789L5.54228 24.0175L5.82288 23.4561L6.94525 22.8947L7.78704 22.0526L6.38407 20.6491L6.10347 18.9649L5.26169 17.2807V15.3158L5.82288 15.0351V13.9123L5.54228 12.5088L5.82288 11.6667L5.54228 10.2632L5.82288 9.70175L5.54228 8.85965L5.82288 7.73684L6.94525 7.17544L7.78704 7.73684L8.34822 7.45614L8.62882 8.57895H9.4706L10.3124 6.89474L11.1542 1C11.1542 1 18.832 2.10364 22.6709 2.51511Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);

export default ArizonaSvg;
